"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorSummary = void 0;
const react_1 = __importStar(require("react"));
const react_outside_click_handler_1 = __importDefault(require("react-outside-click-handler"));
const popovers_1 = require("../../modals/popovers");
const __1 = require("..");
const ErrorSummary_styles_1 = require("./ErrorSummary.styles");
const ErrorSummary = ({ buttonLabel, summary }) => {
    const [hide, hideMenu] = (0, react_1.useState)(true);
    const showHideMenu = () => {
        hideMenu(!hide);
    };
    const onClickOutside = (0, react_1.useMemo)(() => () => {
        if (!hide) {
            hideMenu(!hide);
        }
    }, [hide]);
    return (react_1.default.createElement(react_outside_click_handler_1.default, { onOutsideClick: onClickOutside },
        react_1.default.createElement(ErrorSummary_styles_1.ButtonWrapper, null,
            react_1.default.createElement(__1.ErrorNotificationButton, { label: buttonLabel, onClick: showHideMenu }),
            react_1.default.createElement(ErrorSummary_styles_1.NotificationWrapper, { "$hidden": hide },
                react_1.default.createElement(popovers_1.Notification, { title: summary.title, subTitles: summary.subTitles })))));
};
exports.ErrorSummary = ErrorSummary;
//# sourceMappingURL=ErrorSummary.js.map